import React, { useState } from 'react';
import { authApi } from '../services/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, User } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

export default function ProfilePage() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error('Las claves no coinciden');
      return;
    }
    if (newPassword.length < 4) {
      toast.error('La clave debe tener al menos 4 caracteres');
      return;
    }
    setSaving(true);
    try {
      await authApi.changePassword({
        current_password: currentPassword,
        new_password: newPassword
      });
      toast.success('Clave actualizada exitosamente');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al cambiar clave');
    } finally {
      setSaving(false);
    }
  };

  const roleLabels = { admin: 'Administrador', contractor: 'Contratista', worker: 'Trabajador', client: 'Mandante' };

  return (
    <div className="space-y-6 animate-fade-in max-w-2xl" data-testid="profile-page">
      <div>
        <h1 className="text-2xl font-bold text-[#2B4B8C]">Mi Perfil</h1>
        <p className="text-[#2B4B8C]/60">Información de tu cuenta</p>
      </div>

      <Card className="bg-white border-[#2B4B8C]/10">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-4 pb-4 border-b border-[#2B4B8C]/10">
            <div className="w-14 h-14 rounded-xl bg-[#2BBAA4]/10 flex items-center justify-center">
              <User size={28} className="text-[#2BBAA4]" />
            </div>
            <div>
              <p className="text-lg font-semibold text-[#2B4B8C]">{user?.first_name} {user?.last_name}</p>
              <p className="text-sm text-[#2B4B8C]/50">{user?.email} &middot; {roleLabels[user?.role] || user?.role}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><span className="text-[#2B4B8C]/50">RUT:</span> <span className="text-[#2B4B8C] ml-2">{user?.rut || '-'}</span></div>
            <div><span className="text-[#2B4B8C]/50">Teléfono:</span> <span className="text-[#2B4B8C] ml-2">{user?.phone || '-'}</span></div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white border-[#2B4B8C]/10">
        <CardContent className="p-6">
          <div className="flex items-center gap-3 mb-5">
            <Lock size={22} className="text-[#2B4B8C]" />
            <h2 className="text-lg font-semibold text-[#2B4B8C]">Cambiar Clave</h2>
          </div>
          <form onSubmit={handleChangePassword} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-[#2B4B8C]/80">Clave Actual</Label>
              <Input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="bg-[#f8fafc] border-[#2B4B8C]/10 text-[#2B4B8C]"
                required
                data-testid="current-password"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-[#2B4B8C]/80">Nueva Clave</Label>
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="bg-[#f8fafc] border-[#2B4B8C]/10 text-[#2B4B8C]"
                required
                data-testid="new-password"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-[#2B4B8C]/80">Confirmar Nueva Clave</Label>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="bg-[#f8fafc] border-[#2B4B8C]/10 text-[#2B4B8C]"
                required
                data-testid="confirm-password"
              />
            </div>
            <Button type="submit" disabled={saving} className="bg-[#2BBAA4] text-black hover:bg-[#239986]" data-testid="save-password-btn">
              {saving ? 'Guardando...' : 'Guardar Clave'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
